import { createCompoundComponent } from '../../utilities'

import { Lightbox as BaseLightbox } from './Lightbox'
import { Trigger } from './Trigger'

export const Lightbox = createCompoundComponent(BaseLightbox, {
  Trigger,
})
